import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import MenuWarehouseArticleTypeEdit from './MenuWarehouseArticleTypeEdit';

export default function MenuWarehouseArticleType(props: any) {

    //表头
    const columnsHead = [
        {
            title: '文章大分类',
            dataIndex: 'menuWarehouseArticleCategory',
            render: (text: any) => (
                text ? text.menuWarehouseArticleCategoryName : ""
            )
        },
        {
            title: '文章小分类',
            dataIndex: 'menuWarehouseArticleTypeName',
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
    ];
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '文章小分类',
        apiId: 'menuWarehouseArticleType',
        showStates: true,
        columns,
        pagination: true,
        EditComponent: MenuWarehouseArticleTypeEdit,
    };

    return (
        <WebUniversalNewEx props={extendProps}></WebUniversalNewEx>
    )
}